export const INTERNAL_USE_CATEGORY = 'Minimart Internal use'
export const SECTIONS_TABLE_NAME = 'Sections'
export const SECTION_LINK_FIELD = 'Section'
export const AVAILABILITY_TABLE_NAME = 'Availability'
export const DELIVERY_FEE_ITEM_NAME = 'Delivery Fee'
export const TIP_ITEM_NAME = 'Tip'
export const SALES_TAX_ITEM_NAME = 'Sales Tax'
export const FAMILY_DISCOUNT_ITEM_NAME = 'Family Discount'

export const ALL_APP_ITEM_NAMES = [
  DELIVERY_FEE_ITEM_NAME,
  TIP_ITEM_NAME,
  SALES_TAX_ITEM_NAME,
  FAMILY_DISCOUNT_ITEM_NAME,
]
